<template>
  <div  v-if="outletInfo" class="mb-3"
        :class="[ {'cx-dashboard-header-default': marginOverview }, 
                  {'cx-dashboard-header-nomargin': !marginOverview} ]">
    <CxOutletOverview     :outletInfo="outletInfo"
                          :theme="theme" />
  </div>
</template>

<script>
import CxOutletOverview from './CxOutletOverview.vue';

export default {
  components: {
    CxOutletOverview
  },

  props: {
    dashboardData:          { type: Object, default: () => undefined },
    focusKpis:              { type: Object, default: () => undefined },
    marginOverview:         { type: Object, default: () => undefined },
    outletInfo:             { type: Object, default: () => undefined },
    theme:                  { type: String, default: () => 'light' },
    threshold:              { type: Array, required: true },
    scoreInfo:              { type: Object, default: () => undefined },
    showRetailers:          { type: Boolean, default: () => false },
  }
}
</script>

<style>
  .cx-dashboard-header {
    display: grid;
    grid-gap: 1rem;
    width: calc(100% - 1rem);
  }
  .cx-dashboard-header-default {
    grid-template-columns: 20% 20% 60%;
  }
  .cx-dashboard-header-nomargin {
    grid-template-columns: 20% 60% 20%;
  }
</style>
